import React from 'react';
import { MantineTableDataOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperations';
import { getTotalPages } from '@dealstack/frontend/shared/components/Table/MantineTable/table-utils';
import { TablePagination } from './TablePagination';

interface Props {
	enablePagination: boolean;
	dataOperations?: MantineTableDataOperations;
	rowCount: number;
}

const PAGE_SIZE_OPTIONS = [5, 10, 15, 25, 30, 50, 100];

export const MantineTablePagination: React.FC<Props> = ({
	enablePagination,
	dataOperations,
	rowCount,
}) => {
	if (!enablePagination || !dataOperations?.pagination) {
		return null;
	}

	const { pagination, setPagination } = dataOperations;
	const totalPages = getTotalPages({ rowCount, pageSize: pagination.pageSize });

	// Calculate actual visible rows count
	const startRow = pagination.pageIndex * pagination.pageSize + 1;
	const endRow = Math.min(startRow + pagination.pageSize - 1, rowCount);
	const visibleRowsCount = Math.max(0, endRow - startRow + 1);

	return (
		<TablePagination
			page={pagination.pageIndex + 1}
			pageCount={totalPages}
			pageSize={pagination.pageSize}
			visibleRows={visibleRowsCount}
			pageSizeOptions={PAGE_SIZE_OPTIONS}
			onPageChange={(page) => setPagination({ ...pagination, pageIndex: page - 1 })}
			onPageSizeChange={(pageSize) =>
				setPagination({ ...pagination, pageIndex: 0, pageSize })
			}
		/>
	);
};
